import { flow, getOr, isEqual } from 'lodash/fp';
import { getAttribute } from '../../../../helpers/getAttributeValue';

export default {
  check: (sourceItem, targetItem) => flow(
    getAttribute('flagNotes'),
    getOr(0, 'length'),
    isEqual(0),
  )(targetItem),
  errorMessage: (/* sourceItem, targetItem */) => (
    'Item is flagged'
  ),
};
